// extracted by mini-css-extract-plugin
export default {"locationImage":"Location_locationImage__wjnJO","labelText":"Location_labelText__BeaTG","image":"Location_image__I6jvf"};